/**
 *  Videos
 *  @version 1.0
 *
 *  Loads on each page load and scans for videos. If videos found, loop through all of them and
 *  initialise a video.js instance using the CloudFlare manifest.
 *
 *  Apply the class "cdn-video" to each <video-js> element that you wish to iterate over. Due to
 *  the built-in/bundled CSS, apply either "mobile" or "desktop" after "cdn-video" in order to
 *  hide/show based on screen width (see tailwind.css - input file)
 *
 *  Example:
 *  <video-js class="cdn-video mobile"> or <video-js class="cdn-video desktop">
 */

jQuery(document).ready(function ($) {
    let videos = $(".cdn-video");

    if (videos.length > 0) {
        console.log("Videos found. Loading Video.js");

        let default_options = {
            preload: 'auto',
            controls: true,
            loop: true,
            ratio: "16:9",
            muted: true,
            autoplay: false,
            playsinline: true,
        };

        videos.each(function (index) {
            // Automate the video ID
            let video_id = "video" + index;
            $(this).attr("id", video_id);

            // Grab the data-setup attribute value
            let data_setup = $(this).attr("data-setup");
            let options;

            // If data-setup exists and is not an empty object ("{}"), try parsing it.
            if (data_setup && data_setup.trim() !== "{}") {
                try {
                    console.log(`Options found for ${video_id}`);
                    options = JSON.parse(data_setup);
                } catch (e) {
                    console.error(`Invalid JSON in data-setup attribute for video ${video_id}. Using default options.`);
                    options = default_options;
                }
            } else {
                console.log(`Loading defaults for ${video_id}`);

                // If data-setup is empty or not set, use defaults.
                options = default_options
            }

            // Initialize a new video.js player instance with the selected options.
            videojs(video_id, options);
        });

        return true;
    }

    // console.log("No videos found.");
    return false;
});